import { css } from '@emotion/css'

const userPhotoSize = '132px'

export const cardTop = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const photoActions = css`
  height: 62px;
  transition: transform 0.2s ease;
  width: 100%;
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  transform: translateY(62px);
  bottom: 0;
  background: rgba(0, 0, 0, 0.45);
  color: rgba(255, 255, 255, 0.85);
`

export const userPhotoContainer = css`
  position: relative;
  width: ${userPhotoSize};
  height: ${userPhotoSize};
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  &:hover {
    > [data-photo-actions] {
      z-index: 5;
      transform: translateY(0);
    }
  }
`

export const userPhoto = css`
  width: ${userPhotoSize};
  height: ${userPhotoSize};
  object-fit: cover;
  padding: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
`
export const field = css`
  display:flex;
  flex-direction: column;
  margin: 5% 0
`
